import { render, staticRenderFns } from "./MarkaShow.vue?vue&type=template&id=3d400ded&scoped=true&"
import script from "./MarkaShow.vue?vue&type=script&lang=js&"
export * from "./MarkaShow.vue?vue&type=script&lang=js&"
import style0 from "./MarkaShow.vue?vue&type=style&index=0&id=3d400ded&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d400ded",
  null
  
)

export default component.exports